export enum DataLabelEnum {
  SPOT = 'SPOT',
  PERPETUAL = 'PERPETUAL',
}
